import axios from "axios";
// import { axiosUser } from "config/axios.config";

// const REPORT_URL = "/report";

let BASE_URL_CALL_REPORT = '';
let BASE_URL_WA_REPORT= '';
let BASE_URL_EMAIL_REPORT= '';
let BASE_URL_SMS_REPORT= '';
if(localStorage.getItem('current_set') === 'staging'){
  BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_REPORT_STAGING_QA
  BASE_URL_WA_REPORT = process.env.REACT_APP_WA_REPORT_STAGING
  BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_REPORT_STAGING_Q1
  BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_STAGING
}else{
  BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_RECORD
  BASE_URL_WA_REPORT = process.env.REACT_APP_WA_RECORD
  BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_RECORD
  BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_RATE
}

const configHeader = (appId) => (
  {'x-application-key': `${appId}`,'Content-Type': 'application/json;charset=UTF-8', "Access-Control-Allow-Origin": "*" }
)

const channelUsageSvc = {
    axiosUsageSMS: async (data, appId) => {
        const user = await axios.post(`${BASE_URL_SMS_REPORT}/sms/usage`, 
        data, 
        { headers: configHeader(appId) }
        );
        return user;
    },
    axiosUsageSMSOTP: async (data, appId) => {
        const user = await axios.post(`${BASE_URL_SMS_REPORT}/otp/usage`, 
        data, 
        { headers: configHeader(appId)}
        );
        return user;
    },
    axiosDownloadUsageSMS: async (params, appId) => {
        const user = await axios.get(`${BASE_URL_SMS_REPORT}/sms/usage-download`,
        { 
          params,
          responseType: "blob", 
          headers: configHeader(appId)
        });
        return user;
    },
    axiosDownloadUsageSMSOTP: async (params, appId) => {
        const user = await axios.get(`${BASE_URL_SMS_REPORT}/otp/usage-download`,
        { 
          params,
          responseType: "blob", 
          headers: configHeader(appId) 
        });
        return user;
    },
    axiosGraphicSMS: async (data, appId) => {
      const user = await axios.post(`${BASE_URL_SMS_REPORT}/sms/usage/range-date`, 
      data, 
      { headers: configHeader(appId) }
      );
      return user;
    },
    axiosGraphicOTPSMS: async (data, appId) => {
      const user = await axios.post(`${BASE_URL_SMS_REPORT}/otp/usage/range-date`, 
      data, 
      { headers: configHeader(appId) }
      );
      return user;
    },
    axiosUsageWhatsapp: async (data, appId) => {
      const user = await axios.post(`${BASE_URL_WA_REPORT}/whatsapp-api/usage/total`, 
      data, 
      { headers: configHeader(appId) }
      );
      return user;
    },
    axiosDownloadUsageWhatsapp: async (params, appId) => {
      const user = await axios.get(`${BASE_URL_WA_REPORT}/whatsapp-api/usage/download`,
      { 
        params,
        responseType: "blob", 
        headers: configHeader(appId)
      });
      return user;
    },
    axiosChartSessionWhatsapp: async (data, appId) => {
      const user = await axios.post(`${BASE_URL_WA_REPORT}/whatsapp-api/usage/range-date`, 
      data, 
      { headers: configHeader(appId) }
      );
      return user;
    },
    axiosSessionWhatsapp: async (data, appId) => {
      const user = await axios.post(`${BASE_URL_WA_REPORT}/whatsapp-api/conversation`, 
      data, 
      { headers: configHeader(appId) }
      );
      return user;
    },
    axiosDownloadSessionWhatsapp: async (params, appId) => {
      const user = await axios.get(`${BASE_URL_WA_REPORT}/whatsapp-api/conversation/download`,
      { 
        params,
        responseType: "blob", 
        headers: configHeader(appId)
      });
      return user;
    },
    axiosUsageEmail: async (params, appId) => {
      const user = await axios.post(`${BASE_URL_EMAIL_REPORT}/email/usage/total?start_date=${params.start_date}&end_date=${params.end_date}&application_id=${params.application_id}`, 
      // params,
      '',
      { 
        headers: configHeader(appId)
      });
      return user;
    },
    axiosDownloadUsageEmail: async (params, appId) => {
      const user = await axios.post(`${BASE_URL_EMAIL_REPORT}/email/usage/download?start_date=${params.start_date}&end_date=${params.end_date}&application_id=${params.application_id}`,
      // params,
      '',
      { 
        responseType: "blob", 
        headers:  configHeader(appId)
      });
      return user;
    },
    axiosUsageCall: async (params, appId) => {
      const user = await axios.post(`${BASE_URL_CALL_REPORT}/call/usage/total`, 
      // params, 
      '',
      { 
        params,
        headers: configHeader(appId)
      });
      return user;
    },
    axiosDownloadUsageCall: async (params, appId) => {
      const user = await axios.post(`${BASE_URL_CALL_REPORT}/call/usage/download`,
      '',
      { 
        params,
        responseType: "blob", 
        headers:  configHeader(appId)
      });
      return user;
    },
};

export default channelUsageSvc;
